export const analytics = {
  title: "Analytics",
  subtitle: "Revenue and occupancy for your properties over the period you choose.",
  tabs: {
    performance: "Performance",
    channels: "Channels",
  },
  allAccommodations: "All accommodations",
  compare: {
    prevPeriod: "Previous period",
    prevYear: "Previous year",
    titlePrevPeriod: "Comparison: previous period",
    titlePrevYear: "Comparison: previous year",
    inlinePrevPeriod: "previous period",
    inlinePrevYear: "previous year",
  },
  summary: {
    currentPeriod: "Current period",
    paymentFilter: "Payment filter",
  },
  presets: {
    today: "Today",
    yesterday: "Yesterday",
    d7: "7 days",
    d30: "30 days",
    m3: "3 months",
    m6: "6 months",
    year: "1 year",
  },
  payment: {
    all: "All payments",
    pending: "Pending",
    paid: "Paid",
    rejected: "Rejected",
    refunded: "Refunded",
    partial: "Partial payment",
  },
  kpi: {
    totalRevenue: "Period revenue",
    arrivalRevenue: "Total arrivals value",
    revpar: "RevPAR",
    occupancyRate: "Occupancy rate",
    adr: "ADR",
    avgStay: "Average stay",
    bookingWindow: "Booking window",
  },
  units: {
    days: " days",
  },
  chart: {
    thisPeriod: "This period",
    subtitle: "{current} · compared with {compared} · {payment}",
  },
  channels: {
    directBookings: "Direct bookings",
    otaBookings: "OTA bookings",
    bookingDetails: "Booking details",
    byChannel: "By channel",
    tableChannel: "Channel",
    tableRevenue: "Revenue",
    direct: "Direct",
    ota: "OTA",
    noData: "No data for the selected period",
  },
  a11y: {
    chartOf: "Chart of {label}",
    directVsOta: "Direct vs OTA bookings chart",
  },
};
